import React from 'react';
import protoaiData from '../data/protoai-data.json';

// protoAI Components
import PageHero from './components-protoai/PageHero';

// Extended Appiya Components
import ServicesGrid from './components-services/ServicesGrid';
import ServicesExtended from './components-services/ServicesExtended';
import FeatureExtended from './components-services/FeatureExtended';

const ServicesPage = () => {
  return (
    <div>
      {/* ページヘッダー */}
      <PageHero
        title={protoaiData.services.pageTitle}
        subtitle={protoaiData.services.pageSubtitle}
        breadcrumb="サービス"
      />

      {/* サービス一覧グリッド - 新しいServicesGridコンポーネント */}
      <ServicesGrid
        data={protoaiData.services}
        columns={2}
        showCategories={true}
        hideHeader={true}
        sectionClass="p-80px-tb"
        bgClass="bg-light-gray"
      />

      {/* 詳細サービス説明セクション（オプション - 必要に応じてコメントアウト） */}
      {/*
      <ServicesExtended data={protoaiData.services.fastDev} />
      <FeatureExtended data={protoaiData.services.nurturingDev} />
      <ServicesExtended data={protoaiData.services.specDrivenDev} />
      <FeatureExtended data={protoaiData.services.customBot} />
      <ServicesExtended data={protoaiData.services.residenceService} />
      */}
    </div>
  );
};

export default ServicesPage;